import { WarehousesRepository } from '../repositories/warehouses.repository'
import {
    GetWarehousesParams,
    WarehousesGetByCityIdResponseT,
    WarehousesGetListResponseT,
} from '../types/warehouses.types'

const warehousesRepository = new WarehousesRepository()

export class WarehousesService {
    async getWarehouse(city_id: number): Promise<WarehousesGetByCityIdResponseT> {
        const response = await warehousesRepository.getWarehouse(city_id)
        return response.data
    }

    async getWarehouses(params?: GetWarehousesParams): Promise<WarehousesGetListResponseT> {
        const response = await warehousesRepository.getWarehouses(params)
        return response.data
    }
}
